const styles = {
  title: {
    textAlign: "center",
    fontWeight: "heavy",
    fontSize: 13,
    textDecoration: "underline",
    paddingTop: 20
  },
  signature: {
    display: "flex",
    flexDirection: "row",
    fontWeight: "medium"
  },
  signatureSignLine: {
    left: 7
  },
  signatureNameLine: {
    paddingLeft: 23
  },
  signatureDateLine: {
    paddingLeft: 29
  },
  signaturePlaceLine: {
    paddingLeft: 25
  },
  agreementList: {
    paddingLeft: "5%",
    paddingTop: 10
  },
  headerinfo: {
    paddingTop: 20
  },
  mainText: {
    paddingTop: 30
  },
  agreementText: {
    paddingTop: 15,
    paddingBottom: 5
  }
};

export default styles;
